var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Button, Snackbar } from "@mui/material";
import { isEqual } from "lodash";
import { useTranslation } from "react-i18next";
import SimpleDialog from "./SimpleDialog";
import { useEffect, useState } from "react";
export var useEntity = function (props) {
    var _a, _b;
    var externalDeps = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        externalDeps[_i - 1] = arguments[_i];
    }
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var _d = useState(false), errorLoading = _d[0], setErrorLoading = _d[1];
    var _e = useState(false), saving = _e[0], setSaving = _e[1];
    var _f = useState(false), errorSaving = _f[0], setErrorSaving = _f[1];
    var _g = useState({}), originalItem = _g[0], setOriginalItem = _g[1];
    var _h = useState({}), item = _h[0], setItem = _h[1];
    var _j = useState(false), isMissing = _j[0], setIsMissing = _j[1];
    // Extending the dirty condition using the OR operator
    var isDirty = props.additionalDirtyCondition || !isEqual(originalItem, item);
    var isValid = !isMissing && (props.isValid ? (_a = props.isValid) === null || _a === void 0 ? void 0 : _a.call(props, item) : true);
    var _k = useState(false), savedSnackVisible = _k[0], setSavedSnackVisible = _k[1];
    var _l = useState(false), showConfirmDialog = _l[0], setShowConfirmDialog = _l[1];
    var fetch = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, nextItem, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, 4, 5]);
                    return [4 /*yield*/, props.get()];
                case 1:
                    result = _b.sent();
                    nextItem = result !== null && result !== void 0 ? result : {};
                    setIsMissing(!result);
                    setOriginalItem(nextItem);
                    setItem(nextItem);
                    return [4 /*yield*/, ((_a = props.onFetched) === null || _a === void 0 ? void 0 : _a.call(props, nextItem, setItem, setOriginalItem))];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _b.sent();
                    console.log(e_1);
                    setErrorLoading(true);
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var save = function (onCreated) { return __awaiter(void 0, void 0, void 0, function () {
        var prev, result, wasCreateAction, e_2;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    if (!isValid || !props.create || !props.update)
                        return [2 /*return*/];
                    _j.label = 1;
                case 1:
                    _j.trys.push([1, 6, 7, 8]);
                    prev = __assign({}, originalItem);
                    setSaving(true);
                    result = void 0;
                    wasCreateAction = false;
                    if (!!(item === null || item === void 0 ? void 0 : item.id)) return [3 /*break*/, 3];
                    return [4 /*yield*/, ((_a = props.create) === null || _a === void 0 ? void 0 : _a.call(props, (_c = (_b = props.cleanupBeforeSave) === null || _b === void 0 ? void 0 : _b.call(props, item)) !== null && _c !== void 0 ? _c : item))];
                case 2:
                    result = _j.sent();
                    onCreated === null || onCreated === void 0 ? void 0 : onCreated(result);
                    (_d = props.onCreated) === null || _d === void 0 ? void 0 : _d.call(props, result);
                    wasCreateAction = true;
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, ((_e = props.update) === null || _e === void 0 ? void 0 : _e.call(props, (_g = (_f = props.cleanupBeforeSave) === null || _f === void 0 ? void 0 : _f.call(props, item)) !== null && _g !== void 0 ? _g : item))];
                case 4:
                    result = _j.sent();
                    _j.label = 5;
                case 5:
                    setOriginalItem(result);
                    setItem(result);
                    setIsMissing(false);
                    setSaving(false);
                    result && ((_h = props.onSaved) === null || _h === void 0 ? void 0 : _h.call(props, result, wasCreateAction, prev));
                    setSavedSnackVisible(!!props.showSaveSuccess);
                    return [2 /*return*/, result];
                case 6:
                    e_2 = _j.sent();
                    console.log(e_2);
                    setErrorSaving(true);
                    return [3 /*break*/, 8];
                case 7:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var saveThenSet = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var result, e_3;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    if (isMissing || (props.isValid && !((_a = props.isValid) === null || _a === void 0 ? void 0 : _a.call(props, item))) || !props.create || !props.update)
                        return [2 /*return*/];
                    _k.label = 1;
                case 1:
                    _k.trys.push([1, 6, 7, 8]);
                    setSaving(true);
                    result = void 0;
                    if (!!(item === null || item === void 0 ? void 0 : item.id)) return [3 /*break*/, 3];
                    return [4 /*yield*/, ((_b = props.create) === null || _b === void 0 ? void 0 : _b.call(props, (_d = (_c = props.cleanupBeforeSave) === null || _c === void 0 ? void 0 : _c.call(props, item)) !== null && _d !== void 0 ? _d : item))];
                case 2:
                    result = _k.sent();
                    (_e = props.onCreated) === null || _e === void 0 ? void 0 : _e.call(props, result);
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, ((_f = props.update) === null || _f === void 0 ? void 0 : _f.call(props, (_h = (_g = props.cleanupBeforeSave) === null || _g === void 0 ? void 0 : _g.call(props, item)) !== null && _h !== void 0 ? _h : item))];
                case 4:
                    result = _k.sent();
                    _k.label = 5;
                case 5:
                    setOriginalItem(result);
                    setItem(result);
                    setIsMissing(false);
                    setSaving(false);
                    result && ((_j = props.onSaved) === null || _j === void 0 ? void 0 : _j.call(props, result));
                    setSavedSnackVisible(!!props.showSaveSuccess);
                    return [2 /*return*/, result];
                case 6:
                    e_3 = _k.sent();
                    console.log(e_3);
                    setErrorSaving(true);
                    return [3 /*break*/, 8];
                case 7:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var remove = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setShowConfirmDialog(true);
            return [2 /*return*/];
        });
    }); };
    var handleRemove = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!(item === null || item === void 0 ? void 0 : item.id))
                        return [2 /*return*/];
                    setSaving(true);
                    return [4 /*yield*/, ((_a = props.delete) === null || _a === void 0 ? void 0 : _a.call(props, item.id, (_c = (_b = props.cleanupBeforeSave) === null || _b === void 0 ? void 0 : _b.call(props, item)) !== null && _c !== void 0 ? _c : item))];
                case 1:
                    _e.sent();
                    setItem({});
                    setOriginalItem({});
                    setIsMissing(false);
                    setSaving(false);
                    (_d = props.onDeleted) === null || _d === void 0 ? void 0 : _d.call(props, item);
                    return [2 /*return*/];
            }
        });
    }); };
    // Seed the form with an initial template after an empty find() so the user
    // can explicitly create the (singleton) entity from an empty state.
    var startCreate = function (initial) {
        var next = initial !== null && initial !== void 0 ? initial : {};
        setItem(next);
        setOriginalItem(next);
        setIsMissing(false);
    };
    var handleDuplicate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, id, createDate, updateDate, rest, itemToDuplicate, result, e_4;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!(item === null || item === void 0 ? void 0 : item.id) || !props.create)
                        return [2 /*return*/];
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 6, 7, 8]);
                    setSaving(true);
                    _a = item, id = _a.id, createDate = _a.createDate, updateDate = _a.updateDate, rest = __rest(_a, ["id", "createDate", "updateDate"]);
                    itemToDuplicate = rest;
                    result = void 0;
                    if (!props.duplicate) return [3 /*break*/, 3];
                    return [4 /*yield*/, props.duplicate(itemToDuplicate)];
                case 2:
                    result = _e.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, props.create((_c = (_b = props.cleanupBeforeSave) === null || _b === void 0 ? void 0 : _b.call(props, itemToDuplicate)) !== null && _c !== void 0 ? _c : itemToDuplicate)];
                case 4:
                    result = _e.sent();
                    _e.label = 5;
                case 5:
                    (_d = props.onDuplicate) === null || _d === void 0 ? void 0 : _d.call(props, result);
                    return [2 /*return*/, result];
                case 6:
                    e_4 = _e.sent();
                    console.log(e_4);
                    setErrorSaving(true);
                    return [3 /*break*/, 8];
                case 7:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var t = useTranslation().t;
    useEffect(function () {
        fetch();
    }, externalDeps);
    var renderSnackbars = function () {
        return (_jsxs(_Fragment, { children: [_jsx(Snackbar, __assign({ open: errorLoading, autoHideDuration: 10 * 1000, onClose: function () { return setErrorLoading(false); }, anchorOrigin: { vertical: 'bottom', horizontal: 'center' } }, { children: _jsx(Alert, __assign({ onClose: function () { return setErrorLoading(false); }, severity: "error", action: _jsx(Button, __assign({ onClick: function () {
                                setErrorLoading(false);
                                fetch();
                            } }, { children: t('Reload') })) }, { children: t("Data could not be loaded. Try to refresh the page!") })) })), _jsx(Snackbar, __assign({ open: errorSaving, autoHideDuration: 10 * 1000, onClose: function () { return setErrorSaving(false); }, anchorOrigin: { vertical: 'bottom', horizontal: 'center' } }, { children: _jsx(Alert, __assign({ onClose: function () { return setErrorSaving(false); }, severity: "error" }, { children: t("Changes could not be saved. Check all fields!") })) })), _jsx(Snackbar, __assign({ open: savedSnackVisible, autoHideDuration: 10 * 1000, onClose: function () { return setSavedSnackVisible(false); }, anchorOrigin: { vertical: 'bottom', horizontal: 'center' } }, { children: _jsx(Alert, __assign({ onClose: function () { return setSavedSnackVisible(false); }, severity: "success" }, { children: t("Changes saved!") })) })), _jsx(SimpleDialog, { open: showConfirmDialog, onClose: function () { return setShowConfirmDialog(false); }, message: t('This action cannot be undone'), title: t("Are you sure?!"), confirmText: t('Yes'), cancelText: t('No'), onConfirm: function () {
                        setShowConfirmDialog(false);
                        handleRemove();
                    } }), _jsx(SimpleDialog, { open: false, 
                    // open={blocker.state === 'blocked' && showConfirmDialog}
                    onClose: function () {
                        setShowConfirmDialog(false);
                        // blocker.reset?.()
                    }, message: t('You will lose your changes if you leave this page!'), title: t("You have unsaved changes!"), confirmText: t('Leave'), cancelText: t('Stay') })] }));
    };
    var canDuplicateValue = !!(item === null || item === void 0 ? void 0 : item.id) && (typeof props.canDuplicate === 'function'
        ? props.canDuplicate(item)
        : !!props.canDuplicate);
    return {
        loading: loading,
        setLoading: setLoading,
        errorLoading: errorLoading,
        setErrorLoading: setErrorLoading,
        saving: saving,
        setSaving: setSaving,
        errorSaving: errorSaving,
        setErrorSaving: setErrorSaving,
        originalItem: originalItem,
        setOriginalItem: setOriginalItem,
        item: item,
        setItem: setItem,
        fetch: fetch,
        save: save,
        remove: remove,
        removeNow: handleRemove,
        startCreate: startCreate,
        duplicate: handleDuplicate,
        renderSnackbars: renderSnackbars,
        isValid: isValid,
        isDirty: isDirty,
        isMissing: isMissing,
        saveThenSet: saveThenSet,
        setSavedSnackVisible: setSavedSnackVisible,
        canDelete: !!(item === null || item === void 0 ? void 0 : item.id) && (!props.canDelete || ((_b = props.canDelete) === null || _b === void 0 ? void 0 : _b.call(props, item))),
        canDuplicate: canDuplicateValue,
        isNew: !(item === null || item === void 0 ? void 0 : item.id)
    };
};
